import React from 'react';

import i18nStrings from './strings';
import styles from './styles.modules.scss';
import { useLocalized } from 'utils/useLocalized';
import SearchFilter from './SearchFilter';
import SearchResults from './SearchResults';
import ApiBanner from './ApiBanner';
import {Outlet} from 'react-router-dom';

const Page = () => {
    const strings = useLocalized(i18nStrings);

    return (
        <>
            <div className={styles['page']}>
                <h1 className={styles['header']}>
                    {strings.title}
                </h1>

                <SearchFilter />
                <SearchResults />
                <ApiBanner />
            </div>
            <Outlet/>
        </>
    );
};

export default Page;
